module.exports = __webpack_public_path__ + "static/CorprateHp_16-498a6f77c440a91129f96a4ac79ac416.jpg";